if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.Loader = function() {
    var self = this;
    var template = '{{text}}';
    
    self.show = function(text) {
        var $element = $('#loader-page');
        var html = self.templater.render(template, {text: text});

        $element.find('.progress-text').html(html);
        $element.find('.progress-bar').addClass('active');
        $element.removeClass('invisible').css('top', $(window).scrollTop()).height($(window).height());
        $('html').css('overflow', 'hidden');
    };
    
    self.hide = function() {
        var $element = $('#loader-page');
        $element.addClass('invisible');
        $element.find('.progress-bar').removeClass('active');
        $('html').css('overflow', 'auto');
    };
};